<template>
    <div>
        <v-row no-gutters class="flex-shrink-0 flex-grow-0">
            <v-col cols="12">
                <v-card class="d-flex flex-column" outlined>
                    <v-card-title
                        style="border-bottom: 1px solid #404040"
                        class="pt-1"
                    >
                        <div
                            class="text-left pr-2"
                            style="
                                margin-left: 0;
                                width: 15%;
                                font-size: 13px;
                                font-weight: normal;
                            "
                        >
                            <DanMenu
                                :name="selectedBookName"
                                :menu-items="bookOptions"
                                @dan-menu-click="onMenuItemClick"
                            />
                        </div>
                        <div
                            class="text-right"
                            style="margin-right: 0; width: 85%"
                        >
                            <span>
                                <span
                                    style="font-size: 14px"
                                    v-if="fetchingTime"
                                    >{{ $t("changeSummary.LastFetchedAt") }}:
                                    {{ fetchingTime }}</span
                                >
                                <v-menu offset-y dense>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            color="default"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                            class="ml-1"
                                        >
                                            {{
                                                periodOptions.find(
                                                    (option) =>
                                                        option.value ===
                                                        selectedPeriod
                                                ).key
                                            }}
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-item
                                            v-for="item in periodOptions"
                                            :key="item.key"
                                            @click="
                                                () => {
                                                    selectedPeriod = item.value;
                                                }
                                            "
                                        >
                                            <v-list-item-title>{{
                                                item.key
                                            }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </span>
                        </div>
                        <v-data-table
                            dense
                            :headers="netPositionTableHeaders"
                            :items="netPositionTableData"
                            style="width: 100%"
                            :header-props="{ sortIcon: null }"
                            item-key="symbol"
                            class="elevation-0 flex-grow-1"
                            :items-per-page="30"
                            :footer-props="{
                                itemsPerPageOptions: [10, 20, 30],
                                showFirstLastPage: false,
                                'items-per-page-text': '',
                            }"
                            sortBy="netPositions_change"
                            fixed-header
                            height="350"
                            :customSort="customSort"
                            :loading="loading"
                        >
                            <template
                                v-slot:item.netPositions_change="{ item }"
                            >
                                <div @click="() => handleKeypress(item)">
                                    <span
                                        v-if="item.netPositions_change > 0"
                                        style="color: #27ae60"
                                        >{{ item.netPositions_change }}</span
                                    >
                                    <span
                                        v-else-if="item.netPositions_change < 0"
                                        style="color: #f44336"
                                        >{{ item.netPositions_change }}</span
                                    >
                                    <span v-else>{{
                                        item.netPositions_change
                                    }}</span>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="8" class="pr-2 pt-2">
                <v-card class="d-flex flex-column" outlined>
                    <v-card-title
                        style="border-bottom: 1px solid #404040"
                        class="pt-1"
                    >
                        {{ $t("changeSummary.KPIInformation") }}
                    </v-card-title>
                    <v-row class="pa-4 pb">
                        <v-col
                            cols="4"
                            v-for="item in kpiDetailHeaders"
                            class="pa-2"
                        >
                            <v-card class="mx-auto" max-width="344">
                                <v-card-text>
                                    <div>
                                        {{ item.name }}
                                    </div>
                                    <p class="text text--primary">
                                        {{ kpiDetail[item.key] }}
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="4" class="pt-2">
                <v-card class="d-flex flex-column" outlined>
                    <v-card-title
                        style="border-bottom: 1px solid #404040"
                        class="pt-1"
                    >
                        {{ $t("changeSummary.comment") }}
                    </v-card-title>
                    <v-textarea
                        height="335"
                        filled
                        label=""
                        auto-grow
                        hide-details
                    ></v-textarea>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="visible" width="800" hide-overlay>
            <v-card>
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0"
                        >{{ $t("changeSummary.Top5NetPositionsDetail") }} -
                        {{ selectedSymbol }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" icon @click="visible = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-app-bar>

                <v-data-table
                    dense
                    :loading="modalLoading"
                    item-key="name"
                    :items="netPositionDetailData"
                    :headers="netPositionDetailHeaders"
                    class="elevation-0 alert-datatable"
                    fixed-header
                    hide-default-footer
                >
                </v-data-table>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        :loading="modalLoading"
                        v-on:click="
                            () => {
                                visible = false;
                            }
                        "
                        >Ok</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { helper } from "@components/mixins/helper";
import { getBooksPk } from "@services/books";
import DanMenu from "@views/home/ComponentDanMenu";
import common from "@assets/js/common";
import {
    fetchChangeSummaryData,
    getNetPositionDetail,
} from "@services/change-summary";

export default {
    mixins: [helper],
    components: {
        DanMenu,
    },
    data() {
        return {
            bookOptions: [],
            selectedBook: "",
            netPositionTableHeaders: [
                { text: this.$t("common.table.symbol"), value: "symbolName" },
                {
                    text: this.$t("common.table.netPositionLast"),
                    value: "netPositions_prev",
                    align: "end",
                },
                {
                    text: this.$t("common.table.netPositionNew"),
                    value: "netPositions_curr",
                    align: "end",
                },
                {
                    text: this.$t("common.table.netPositionChanged"),
                    value: "netPositions_change",
                    align: "end",
                },
                {
                    text: this.$t("common.table.netPNLChange"),
                    value: "netPNL_change",
                    align: "end",
                },
            ],
            periodOptions: [
                { key: this.$t("common.time.5min"), value: 5 },
                { key: this.$t("common.time.10min"), value: 10 },
                { key: this.$t("common.time.15min"), value: 15 },
                { key: this.$t("common.time.30min"), value: 30 },
                { key: this.$t("common.time.1hr"), value: 60 },
            ],
            kpiDetailHeaders: [
                {
                    name: this.$t("common.table.unrealizedLast"),
                    key: "unrealized_last",
                },
                {
                    name: this.$t("common.table.unrealizedNew"),
                    key: "unrealized_new",
                },
                {
                    name: this.$t("common.table.changed"),
                    key: "unrealized_changed",
                },
                {
                    name: this.$t("common.table.realizedLast"),
                    key: "realized_last",
                },
                {
                    name: this.$t("common.table.realizedNew"),
                    key: "realized_new",
                },
                {
                    name: this.$t("common.table.changed"),
                    key: "realized_changed",
                },
                { name: this.$t("common.table.netLast"), key: "net_last" },
                { name: this.$t("common.table.netNew"), key: "net_new" },
                { name: this.$t("common.table.changed"), key: "net_changed" },
            ],
            selectedPeriod: 60,
            netPositionTableData: [],
            fetchingTime: null,
            kpiDetail: {},
            loading: false,
            mt4Time: null,
            prevMt4Time: null,
            visible: false,
            selectedSymbol: null,
            modalLoading: false,
            netPositionDetailHeaders: [
                { text: this.$t("common.table.login"), value: "login" },
                {
                    text: this.$t("common.table.netPositionLast"),
                    value: "netPositions_prev",
                    align: "end",
                },
                {
                    text: this.$t("common.table.netPositionNew"),
                    value: "netPositions_curr",
                    align: "end",
                },
                {
                    text: this.$t("common.table.netPositionChanged"),
                    value: "netPositions_change",
                    align: "end",
                },
            ],
            netPositionDetailData: [],
        };
    },
    computed: {
        selectedBookName() {
            return `${this.selectedBook} BOOK`;
        },
    },
    watch: {
        selectedPeriod() {
            this.fetchData();
        },
        selectedBook() {
            this.fetchData();
        },
    },
    methods: {
        onMenuItemClick(item) {
            this.selectedBook = item;
        },
        fetchData() {
            this.loading = true;
            this.mt4Time = common.getMT4TimeStringWithTimeDelta(1);
            this.prevMt4Time = common.getMT4TimeStringWithTimeDelta(
                this.selectedPeriod + 1
            );
            this.fetchingTime = common.getMT4TimeString();
            const tableParam = {
                book: this.selectedBook,
                currTime: this.mt4Time,
                prevTime: this.prevMt4Time,
            };
            fetchChangeSummaryData(tableParam)
                .then(({ data }) => {
                    for (const key of Object.keys(data.desc)) {
                        data.desc[key] = data?.desc[key]?.toFixed(2);
                    }
                    this.kpiDetail = data.desc;
                    this.netPositionTableData = data.table;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        customSort(items, sortBy, sortDesc) {
            items.sort((a, b) => {
                if (
                    sortBy[0] === "netPositions_prev" ||
                    sortBy[0] === "netPositions_curr" ||
                    sortBy[0] === "netPositions_change" ||
                    sortBy[0] === "netPNL_change"
                ) {
                    if (sortDesc[0]) {
                        return Math.abs(a[sortBy]) - Math.abs(b[sortBy]);
                    }
                    if (!sortDesc[0]) {
                        return Math.abs(b[sortBy]) - Math.abs(a[sortBy]);
                    }
                } else {
                    if (!sortDesc[0]) {
                        return a[sortBy] < b[sortBy] ? -1 : 1;
                    } else {
                        return b[sortBy] < a[sortBy] ? -1 : 1;
                    }
                }
            });
            return items;
        },
        handleKeypress(item) {
            this.visible = true;
            this.selectedSymbol = item.symbolName;
            this.modalLoading = true;
            this.netPositionDetailData = [];
            const tableParam = {
                book: this.selectedBook,
                currTime: this.mt4Time,
                prevTime: this.prevMt4Time,
                symbol: item.symbolName,
            };
            getNetPositionDetail(tableParam)
                .then(({ data }) => {
                    this.netPositionDetailData = data?.change;
                })
                .finally(() => {
                    this.modalLoading = false;
                });
        },
    },
    created() {
        getBooksPk().then(({ data }) => {
            const result = [];
            for (const item of data) {
                if (!!item.children) {
                    result.push({
                        name: item.book_name,
                        parent: null,
                        children: item.children,
                    });
                    for (const child of item.children) {
                        result.push({
                            name: child.book_name,
                            parent: item.book_name,
                            children: child.children || null,
                        });
                    }
                } else {
                    result.push({
                        name: item.book_name,
                        parent: null,
                        children: null,
                    });
                }
            }
            this.bookOptions = data;
            if (!data.find((item) => item.book_name === "B")) {
                this.selectedBook = data[0].book_name;
            } else {
                this.selectedBook = "B";
            }
        });

        // window.addEventListener("keypress", this.handleKeypress);
    },
    destroyed() {
        // window.removeEventListener("keypress", this.handleKeypress);
    },
};
</script>

<style></style>
